export enum MpTooltipPosition {
  Above = 'above',
  Below = 'below',
  Left = 'left',
  Right = 'right'
}
